import type HttpClient from "../../tastyworks/http"
import {
  NEWS_ITEM_DESER,
  NEWS_URN_DESER,
  NewsItem,
  NewsUrn,
  TOP_NEWS_ITEM_DESER,
  TOP_NEWS_STORY_DESER,
  TopNewsItem,
  TopNewsStory,
} from "../../tastyworks/news"
import type { Params } from "../../tastyworks/request"
import {
  parseItemsResponse,
  parseSingleResponse,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks/response"

export default class NewsService {
  readonly baseHttpClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.baseHttpClient = baseHttpClient
  }

  readonly index = async (
    symbol: string,
    exchange: string,
    instrumentType?: string
  ): Promise<ItemsResponse<NewsItem>> => {
    const params: Params = {
      symbol,
      exchange,
      "instrument-type": instrumentType ?? "",
    }

    const helper = await this.baseHttpClient.get("/news", params)

    return parseItemsResponse(helper, NEWS_ITEM_DESER.toParser(NewsItem))
  }

  readonly show = async (urn: string): Promise<SingleResponse<NewsUrn>> => {
    const helper = await this.baseHttpClient.get(`/news/${urn}`)

    return parseSingleResponse(helper, NEWS_URN_DESER.toParser(NewsUrn))
  }

  readonly topNews = async (
    topic: string
  ): Promise<ItemsResponse<TopNewsItem>> => {
    const helper = await this.baseHttpClient.get(`/top-news/${topic}`)

    return parseItemsResponse(helper, TOP_NEWS_ITEM_DESER.toParser(TopNewsItem))
  }

  readonly topNewsStory = async (
    id: string
  ): Promise<SingleResponse<TopNewsStory>> => {
    const helper = await this.baseHttpClient.get(`/top-news-story/${id}`)

    return parseSingleResponse(
      helper,
      TOP_NEWS_STORY_DESER.toParser(TopNewsStory)
    )
  }
}
